/**
 * 基于最新 next/image 的版本
 *
 * P1 全局化后：
 *   - loader 由 common.next.config.js 全局接管，组件内不再传 loader prop
 *   - errorImg + onError 兜底逻辑保留
 *   - 反模式修复 1：移除 useState(src)+useEffect sync（初始值够了）
 *   - 反模式修复 2：src 变化时的 fallback 切换改用 key={src}（避免手写 reducer）
 */
import { useState, useCallback } from 'react';
import Image, { ImageProps } from 'next/image';

type MMImageProps = ImageProps & {
  // 图片加载错误时兜底图
  errorImg?: string;
  // 是否动图，当为动图时，不能使用cdn loader
  isAni?: boolean;
  // 是否使用cdn转化为 webp
  formatWebp?: boolean;
};

export const MMImage = (props: MMImageProps) => {
  // isAni / formatWebp 由全局 imageLoader 按 src 扩展名自动识别，不再从 props 消费；
  // 保留在 MMImageProps 类型中以便旧调用点无缝迁移；这里解构出来阻止它们漏到 ...rest
  // 继而被 <Image> 透传到 DOM（next/image 会对未知 prop 告警）。
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  const { src = '', errorImg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNs2AQAAbgBNMqymOwAAAAASUVORK5CYII=', isAni, formatWebp, ...rest } = props;
  const [imgSrc, setImgSrc] = useState(src);
  const handleError = useCallback(() => setImgSrc(errorImg), [errorImg]);

  // key={String(src)} 确保 src 变化时组件重建，imgSrc 重置为新 src（而非残留旧 errorImg）
  return <Image {...rest} key={String(src)} src={imgSrc} onError={handleError} />;
};
export default MMImage;
